import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    // Placeholder for future settings interactions
  }

  handleSubmit(event) {
    try {
      console.log('Form submit handler called');
      console.log('Event target:', event.target);
      const submitButton = event.target.querySelector('button[type="submit"]');
      console.log('Submit button found:', submitButton);
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = this.t('js.rh.teacher_attendances.settings.buttons.submitting');
        console.log('Submit button disabled and text changed');
      } else {
        console.log('No submit button found');
      }
      // Don't prevent default - let the form submit normally
      console.log('Form submission allowed to continue');
    } catch (error) {
      console.error('Error in handleSubmit:', error);
    }
  }

  t(key, options = {}) {
    if (typeof window !== "undefined" && typeof window.t === "function") {
      return window.t(key, options);
    }
    return key;
  }
}
